import React, { memo, useMemo } from 'react'
import { TTrainerHorse } from '../../shared/types/trainerHorse.type'
import { Box, Grid, Typography } from '@mui/material'
import HorseCard from './HorseCard'
import { t } from 'i18next'
import { routes } from '../../pages/routes'
import { useNavigate } from 'react-router-dom'
import { isEmpty, uniqBy } from 'lodash'

function Horses({ horses, onChange, onEdit }: { horses: TTrainerHorse[], onChange: (id: number, checked: boolean) => void, onEdit: (horse: TTrainerHorse) => void }) {



    const uniq_by_id_horses = useMemo(() => {
        if (isEmpty(horses)) return []
        return uniqBy(horses, i => i.horse['@id'])
    }, [horses])


    if (uniq_by_id_horses.length === 0) {
        return <Box display={'flex'} justifyContent={'center'} alignItems={'center'} pt={2} >
            <Typography variant='subtitle2'>{t('filterTrainings:noResults')}</Typography>
        </Box>
    }




    return (
        <Grid container spacing={2}>
            {uniq_by_id_horses.map(horse => (
                <Grid key={horse.id} item md={4} sm={6} xs={12}>
                    <HorseCard onEdit={onEdit} onChange={onChange} horse={horse}></HorseCard>
                </Grid>
            ))}
        </Grid>
    )
}

export default memo(Horses)